/**
 * Navigation Module Config
 * @author Rhys Lloyd
 */

export const GEOLOCATION_BUTTON_DATA_ATTRIBUTE = 'data-geocode-target';
export const GEOLOCATION_BUTTON_SELECTOR = `[${GEOLOCATION_BUTTON_DATA_ATTRIBUTE}]`;

export const SEARCH_FIELD_NAME = 'q';
export const LAT_FIELD_NAME = 'lat';
export const LNG_FIELD_NAME = 'lng';
export const GPS_FIELD_NAME = 'gps';

export const MAP_VIEW_BUTTON_SELECTOR = 'button[name="display"][value="map"]';
export const MAP_VIEW_BUTTON_ACTION_DATA_ATTRIBUTE = 'action';

export const LIST_VIEW_BUTTON_SELECTOR = 'button[name="display"][value="list"]';
export const LIST_VIEW_BUTTON_ACTION_DATA_ATTRIBUTE = 'action';



// WEBPACK FOOTER //
// ./project/client/src/core/modules/navigation/config.js